import { cx } from '@emotion/css';
import { ArrowDropDownRounded, ArrowDropUpRounded, SubdirectoryArrowRight } from '@mui/icons-material';
import { forwardRef, Fragment, useEffect, useState } from 'react';

import { Levels } from '_core/utils/public-links/_types';

import * as S from '../styles';

export type AsideItemProps = {
  levels: Levels;
  levelKey: string;
  key: number | string;
  openDropdown: (param: string) => void;
  selectedLevel: string;
  executeScroll: (e: string) => void;
  isOpen?: boolean;
  openAsideDropdown: (param: string) => void;
};

export const AsideItem = (props: AsideItemProps) => {
  const { openAsideDropdown, executeScroll, levelKey, openDropdown, selectedLevel, isOpen, levels } = props;
  const [isSelected, setIsSelected] = useState<boolean>(false);

  const handleClick = (link: string) => {
    openAsideDropdown(link);
    executeScroll(link);
    if (selectedLevel === link) {
      setIsSelected(!isSelected);
    }
  };

  useEffect(() => {
    setIsSelected(selectedLevel === levelKey);
  }, [selectedLevel, levelKey]);

  return (
    <div className="my-1">
      <S.IndexItem
        selected={isSelected}
        onClick={() => handleClick(levelKey)}
        onKeyDown={() => handleClick(levelKey)}
        className="cursor-pointer py-2 px-3 rounded-md layout-row layout-align-start-center">
        <div className="flex-1 small lh-3" role="button" tabIndex={0}>
          {levelKey}
        </div>
        <div
          onClick={() => handleClick(levelKey)}
          onKeyDown={() => handleClick(levelKey)}
          role="button"
          tabIndex={0}
          className="layout-column layout-align-center-center">
          {!levels[levelKey].hasOwnProperty('null') && (
            <Fragment>
              {isSelected && isOpen ? (
                <ArrowDropUpRounded style={{ fontSize: 24 }} className="text-primary-500" />
              ) : (
                <ArrowDropDownRounded
                  style={{ fontSize: 24 }}
                  className={cx(isSelected ? 'text-primary-500' : 'text-secondary-900')}
                />
              )}
            </Fragment>
          )}
        </div>
      </S.IndexItem>
      {!levels[levelKey].hasOwnProperty('null') && isSelected && (
        <S.Gradient className="relative">
          <S.ScrollingArea
            className={cx(
              Object.keys(levels[levelKey]).length > 8 && 'pb-12',
              'overflow-y-auto my-2 p-2 rounded-md bg-secondary-50 ',
            )}>
            {Object.keys(levels[levelKey])?.map((subLevel) => {
              return (
                <div key={subLevel} className="my-1">
                  <S.IndexItem
                    subLevel={true}
                    onClick={() => openDropdown(subLevel)}
                    onKeyDown={() => openDropdown(subLevel)}
                    role="button"
                    tabIndex={0}
                    className="cursor-pointer py-2 px-3 rounded-md layout-row layout-align-start-center">
                    <SubdirectoryArrowRight style={{ fontSize: 14 }} className="mr-2 text-secondary-500" />
                    <div className="small text-truncate">{subLevel}</div>
                  </S.IndexItem>
                </div>
              );
            })}
          </S.ScrollingArea>
        </S.Gradient>
      )}
    </div>
  );
};
